function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr))
    return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import flat from 'flat';
import fetchErrorFromResponse from '@nordvpn/teams.core/lib/tools/fetchErrorFromResponse';
import { isAxiosRequestError } from 'utils/guards/isRequestError';
/**
 * Joins QueryKeys together.
 *
 * @param a - query key to merge
 * @param b - query key to append
 * @returns merged query key as an array
 */
export var joinKeys = function joinKeys(a, b) {
    return [].concat(_toConsumableArray(Array.isArray(a) ? a : [a]), _toConsumableArray(Array.isArray(b) ? b : [b]));
};
/**
 * Gets a string representing an error from react-query mutation error or other API call errors.
 *
 * @param e - query error object
 */
export var getErrorFromQueryError = function getErrorFromQueryError(e) {
    if (isAxiosRequestError(e)) {
        var axiosBackendErrorMessage = e.response.data.message;
        if (axiosBackendErrorMessage) {
            return axiosBackendErrorMessage;
        }
    }
    if (_typeof(e) === 'object') {
        return fetchErrorFromResponse(e.response);
    }
    return fetchErrorFromResponse(null);
};
/**
 * Flatten query params object for query key.
 */
export var flatten = flat;
